import React, { useEffect, useState, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "components/Common/TableContainer";
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Modal,
    ModalHeader,
    ModalBody,
    Label,
    FormFeedback,
    Input,
    Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import Select from "react-select";
import toast from "react-hot-toast";
import { ReactTransliterate } from "react-transliterate";
import "react-transliterate/dist/index.css";
import { isEmpty } from "lodash";
//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { addNewSert, changeStatus, getClass, getSerts, updateSert } from "helpers/fakebackend_helper";

const ScertList = () => {

    //meta title
    document.title = "Subject List";

    const router = useNavigate();

    const { state } = useLocation()

    const dispatch = useDispatch();
    const [contact, setContact] = useState();
    const [contacts, setContacts] = useState();
    const [load, setload] = useState(false);
    const [text, setText] = useState("");
    const [mainClass, setMinClass] = useState([]);
    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(true);
    const [isLoading, setLoading] = useState(false)
    const [isId, setIsid] = useState(state?.id)
    const [list, setList] = useState([])

    // validation
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: (contact && contact.name1) || "",
            status: (contact && contact.status) || "",
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Please Enter Your Name"),
        }),
        onSubmit: values => {
            setload(true)
            if (isEdit) {
                const updateUser = {
                    id: contact.id,
                    name1: values.name,
                    status: values.status
                };
                updateFun(updateUser)
            } else {
                const newUser = {
                    parent_id: state?.id ?? null,
                    name1: values["name"],
                    // status: values.status,
                };
                addFun(newUser)
            }
            // toggle();
        },
    });

    const validations = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: (contacts && contacts.name) || "",
            order_by: (contacts && contacts.order_by) || "",
            tamil_name: (contacts && contacts.tamil_name) || "",
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Please Enter English Title"),
            // tamil_name: Yup.string().required("Please Enter Tamil Name"),
            // order_by: Yup.string().required("Please Enter Order by"),
        }),
        onSubmit: values => { 
            if(!text){
                
            }
            setload(true)
            if (isEdit) {
                const updateSub = {
                    scert_master_id: contacts.id,
                    eng_name: values["name"],
                    tamil_name: text,
                    order_by: values['order_by']
                };
                // update user
                // dispatch(onUpdateSert(updateSub));
                // setIsEdit(false);
                // validation.resetForm();
                updateFun(updateSub);
            } else {
                const newSub = {
                    parent_id: isId ?? state?.id ?? null,
                    eng_name: values["name"],
                    tamil_name: text ?? '',
                    order_by: values['order_by']
                };
                // save new user
                // dispatch(onAddNewSert(newSub));
                // validation.resetForm();
                addFun(newSub)
            }
            // toggle();
        },
    });


    const getView = () => {
        setLoading(true)
        getClass(state?.id).then((res) => {
            setContact(res?.[0]);
            setLoading(false)
        }).catch((err) => {
            console.log('err', err)
            setLoading(false)
        })
    }

    const getList = (id) => {
        setLoading(true)
        getSerts(id ?? isId ?? state?.id).then((res) => {
            setList(res)
            setLoading(false)
        }).catch((err) => {
            console.log('err', err)
            setLoading(false)
        })
    }


    useEffect(() => {
        // if (state?.id) {
        //     // getView()
        // }
        if (state?.id) {
            getList(state?.id)
            setIsid(state?.id)
        }
    }, [state?.id]);

    const addFun = (payload) => {
        addNewSert(payload).then((res) => {
            if (res?.success) {
                validation.resetForm()
                validations.resetForm()
                getList(isId)
                setload(false)
                setModal(false)
                toast.success('Added Success')
            } else {
                toast.error(res?.message ?? 'somthing went wrong!')

            }
        }).catch((err) => {
            console.log('err', err)
            setload(false)
        })
    }

    const updateFun = (payload) => {
        updateSert(payload).then((res) => {
            if (res?.success) {
                validation.resetForm()
                validations.resetForm()
                getList(isId)
                setIsEdit(false);
                setload(false)
                setModal(false)
                toast.success('Updated Success')
            } else {
                toast.error(res?.message ?? 'somthing went wrong!')

            }
        }).catch((err) => {
            console.log('err', err)
            setload(false)
        })
    }


    // useEffect(() => {
    //     if (state?.id) {
    // fetchclass(state?.id)
    //         setIsEdit(false);
    //     }   
    // }, [state?.id]);
    // }, [dispatch, users]);


    const toggle = () => {
        setModal(!modal);
    };

    const handleSubClicks = () => {
        setIsEdit(false);
        setContacts('')
        toggle();
    };


    const handleSubClick = arg => {
        const sub = arg;
        setContacts({
            id: sub.id,
            name: sub.name1,
            tamil_name: sub.name2,
            order_by: sub.order,
            status: sub.status
        })
        setText(sub.name2)
        setIsEdit(true);
        toggle();
    };

    const handleStatus = (status) => {
        changeStatus(status).then(res => {
            if (res?.success) {
                getList(isId);
                toast.success(res?.message ?? 'Status Updated')
            } else {
                toast.error(res?.message ?? 'somthing went wrong!')
            }
        }).catch(err => {
            console.log('err', err);
        })
    }

    const columns = useMemo(
        () => [
            {
                header: "SNO",
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cell, row) => {
                    return (
                        <>
                            <h5 className='font-size-14 mb-1'>
                                {cell.row.index + 1}
                            </h5>
                        </>
                    )
                }
            },
            {
                header: 'English Title',
                accessorKey: 'name1',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cell) => {
                    return (
                        <>
                            <h5 className='font-size-14 mb-1'>
                                <Link to='#' className='text-dark'>{cell.getValue()}</Link>
                            </h5>
                        </>
                    )
                }
            },
            {
                header: 'Tamil Title',
                accessorKey: 'name2',
                enableColumnFilter: false,
                enableSorting: true,
            },

            {
                header: 'Status',
                // accessorKey: 'status',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cell) => {
                  return (
                    <div>
                      {
                        cell.row.original?.status ?
                        <button type="button" onClick={() => handleStatus(cell.row.original?.id)} className="btn btn-success">Active</button>
                        :
                        <button type="button" onClick={() => handleStatus(cell.row.original?.id)} className="btn btn-danger">Deactive</button>
                      }
                    </div>
                  );
                },
              },

            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cellProps) => {
                    return (
                        <div className="d-flex gap-3">

                            <Link
                                to="/medium"
                                state={{ id: cellProps.row.original?.id }}
                                className="text-primary"
                            >
                                <i className="mdi mdi-eye font-size-18" id="deletetooltip" />
                            </Link>

                            <Link
                                to="#"
                                className="text-success"
                                onClick={() => {
                                    const subData = cellProps.row.original;
                                    handleSubClick(subData);
                                }}
                            >
                                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                            </Link>
                        </div>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>

            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="CLASS" breadcrumbItem="SUBJECT LIST" />
                    {/* <div className="card d-none">
                        <div className="card-body">
                            <Form
                                onSubmit={e => {
                                    e.preventDefault();
                                    setIsEdit(true);
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <Row className="align-items-end">
                                    <Col md={5} className="">
                                        <div className="mb-3">
                                            <Label className="form-label">Name</Label>
                                            <Input
                                                name="name"
                                                type="text"
                                                placeholder="Insert Name"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.name || ""}
                                                invalid={
                                                    validation.touched.name &&
                                                        validation.errors.name
                                                        ? true
                                                        : false
                                                }
                                            />
                                            {validation.touched.name &&
                                                validation.errors.name ? (
                                                <FormFeedback type="invalid">
                                                    {validation.errors.name}
                                                </FormFeedback>
                                            ) : null}
                                        </div>
                                    </Col>

                                    <Col md="5">
                                        <div className="mb-3">
                                            <Label>Select Status</Label>
                                            <Select
                                                placeholder='Select Status'
                                                options={[{ label: 'Active', value: true }, { label: 'Inactive', value: false }]}
                                                getOptionLabel={(e) => e.label}
                                                getOptionValue={(e) => e.value}
                                                value={[{ label: 'Active', value: true }, { label: 'Inactive', value: false }].find(e => e.value == validation.getFieldProps('status').value)}
                                                onChange={(e) => { validation.setFieldValue('status', e?.value) }}
                                                className="select2-selection"
                                            />
                                        </div>
                                    </Col>

                                    <Col md={2} >
                                        <div className="text-end mb-3">
                                            <button
                                                type="submit"
                                                className="btn btn-success save-user w-100"
                                            >
                                                Update
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </div> */}

                    <Row>
                        {
                            isLoading ? <Spinners setLoading={setLoading} />
                                :
                                <Col lg="12">
                                    <Card>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={list || []}
                                                isGlobalFilter={true}
                                                isPagination={true}
                                                SearchPlaceholder="Search..."
                                                isAddButton={true}
                                                // isCustomPageSize={true}
                                                handleUserClick={handleSubClicks}
                                                buttonClass="btn btn-success btn-rounded waves-effect waves-light addContact-modal mb-2"
                                                buttonName="Add Subject"
                                                tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                                pagination="pagination"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                        }

                        <Modal isOpen={modal} toggle={toggle}>
                            <ModalHeader toggle={toggle} tag="h4">
                                {!!isEdit ? "Edit Subject" : "Add Subject"}
                            </ModalHeader>
                            <ModalBody>
                                <Form
                                    onSubmit={e => {
                                        e.preventDefault();
                                        validations.handleSubmit();
                                        return false;
                                    }}
                                >
                                    <Row>
                                        <Col xs={12}>
                                            <div className="mb-3">
                                                <Label className="form-label">English Title<span className="text-danger">*</span></Label>
                                                <Input
                                                    name="name"
                                                    type="text"
                                                    placeholder="English Title"
                                                    onChange={validations.handleChange}
                                                    onBlur={validations.handleBlur}
                                                    value={validations.values.name || ""}
                                                    invalid={
                                                        validations.touched.name &&
                                                            validations.errors.name
                                                            ? true
                                                            : false
                                                    }
                                                />
                                                {validations.touched.name &&
                                                    validations.errors.name ? (
                                                    <FormFeedback type="invalid">
                                                        {validations.errors.name}
                                                    </FormFeedback>
                                                ) : null}
                                            </div>
                                        </Col>
                                        <Col xs={12}>
                                            <div className="mb-3">
                                                <Label className="form-label">Tamil Title<span className="text-danger">*</span></Label>
                                                <ReactTransliterate
                                                    value={text}
                                                    onChangeText={setText}
                                                    lang="ta" // Tamil Language
                                                    name="tamil_name"
                                                    placeholder="Tamil Title"
                                                    style={{
                                                        width: "100%",
                                                        padding: "7px",
                                                        // fontSize: "16px",
                                                        border: "1px solid #ccc",
                                                        borderRadius: "5px",
                                                    }}
                                                />
                                                {validations.touched.tamil_name &&
                                                    validations.errors.tamil_name ? (
                                                    <FormFeedback type="invalid">
                                                        {validations.errors.tamil_name}
                                                    </FormFeedback>
                                                ) : null}
                                            </div>
                                        </Col>
                                        <Col xs={12}>
                                            <div className="mb-3">
                                                <Label className="form-label">Order By<span className="text-danger">*</span></Label>
                                                <Input
                                                    name="order_by"
                                                    type="text"
                                                    placeholder="Order By"
                                                    onChange={validations.handleChange}
                                                    onBlur={validations.handleBlur}
                                                    value={validations.values.order_by || ""}
                                                    invalid={
                                                        validations.touched.order_by &&
                                                            validations.errors.order_by
                                                            ? true
                                                            : false
                                                    }
                                                />
                                                {validations.touched.order_by &&
                                                    validations.errors.order_by ? (
                                                    <FormFeedback type="invalid">
                                                        {validations.errors.order_by}
                                                    </FormFeedback>
                                                ) : null}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <div className="text-end">
                                                <button
                                                    type="submit"
                                                    className="btn btn-success save-user"
                                                >
                                                    {
                                                        load ?
                                                            <>
                                                                <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                                                Loading
                                                            </> : !!isEdit ? "Update" : "Save"
                                                    }
                                                </button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                            </ModalBody>
                        </Modal>
                    </Row>
                </Container>
            </div>

        </React.Fragment>
    );
};

export default withRouter(ScertList);
